import { useCachedQuery } from 'sierra-client/state/api'
import { LiveSessionId } from 'sierra-domain/api/nano-id'
import { XRealtimeContentLiveSessionRecap } from 'sierra-domain/routes'

export const useHasRecapAvailable = (liveSessionId: LiveSessionId): boolean => {
  const queryResult = useCachedQuery(XRealtimeContentLiveSessionRecap, { liveSessionId }, { retry: false })
  return queryResult.isSuccess
}
